module.exports = __webpack_public_path__ + "img/hr-style.5a93919.png";